export default __webpack_public_path__ + "static/media/david-marcu.0e300075.jpg";